import React from 'react'
import {MdOutlineDownloadForOffline} from 'react-icons/md';



const LandingPage = () => {
  return (
    <div className=' bg-[#142d4c] h-[100vh]' id='home' >
        
        <div className='landing_page flex items-center h-[90vh] justify-around'> 
            <div className=' '>
                <h1 className=' text-3xl text-white'>Hi, I am</h1>
                <h1 className=' text-5xl text-white font-extrabold mt-3 sm:pl-10 lg:pl-0'>MANI SHANKAR <br  /> <span className=' mt-5 font-semibold'>VASA</span></h1>
                <button className=' flex items-center px-6 bg-gray-200 p-2 mt-6 rounded-md hover:bg-[#655DBB] hover:text-white hover:duration-300 transition ease-in-out'> <MdOutlineDownloadForOffline className=' text-lg mr-2' /><a href="https://drive.google.com/file/d/1_D4t-CgSXzPUoHoY8vr2-bNG8OZXocH0/view?usp=sharing" download='Mani Shankar resume'>Resume</a></button>
            </div>
            <div>
                <img src="https://react-tailwindcss-portfolio.netlify.app/static/media/developer-dark.3f07bd13.svg" className='landing_image w-[530px] h-auto' alt="..." />
            </div>
            
        </div>
    </div>
  )
}

export default LandingPage